/**
 * Shop Services API Endpoints
 * 
 * ⭐ SINGLE SOURCE OF TRUTH - All Shop API endpoints defined here
 * If API endpoints change, update ONLY this file
 */

export const SHOP_ENDPOINTS = {
  // ============================================
  // SELLERS
  // ============================================
  SELLERS: {
    LIST: '/api/v1/shop/sellers',
    ADD: '/api/v1/shop/sellers/add',
    UPDATE: (id: string) => `/api/v1/shop/sellers/${id}/update`,
    GET_BY_ID: (id: string) => `/api/v1/shop/sellers/find-by-id/${id}`,
    DELETE: (id: string) => `/api/v1/shop/sellers/${id}/delete`,
  },

  // ============================================
  // SELLER LOCATIONS
  // ============================================
  SELLER_LOCATIONS: {
    LIST: '/api/v1/shop/sellers/locations/list',
    ADD: '/api/v1/shop/sellers/locations/add',
    UPDATE: (id: string) => `/api/v1/shop/sellers/locations/${id}/update`,
    GET_BY_ID: (id: string) => `/api/v1/shop/sellers/locations/find-by-id/${id}`,
    DELETE: (id: string) => `/api/v1/shop/sellers/locations/${id}/delete`,
    ALL: '/api/v1/shop/sellers/locations/all', // New endpoint for getting all available locations
  },

  // ============================================
  // PRODUCTS
  // ============================================
  PRODUCTS: {
    LIST: '/api/v1/shop/catalogue/manage/items',
    ADD: '/api/v1/shop/catalogue/items',
    UPDATE: (id: string) => `/api/v1/shop/catalogue/items/${id}`,
    GET_BY_ID: (id: string) => `/api/v1/shop/catalogue/items/${id}`,
    DELETE: (id: string) => `/api/v1/shop/catalogue/items/delete/${id}`,
    UPDATE_STATUS: (id: string) => `/api/v1/shop/catalogue/items/${id}`,
    LIST_BY_FILTERS: '/api/v1/shop/catalogue/manage/items/find-by-filters',
    CONFIGS: '/api/v1/shop/catalogue/configs',
  },

  // ============================================
  // ORDERS
  // ============================================
  ORDERS: {
    LIST: '/api/v1/shop/orders',
    GET_BY_ID: (id: string) => `/api/v1/shop/orders/${id}`,
    MANAGE_LIST: '/api/v1/shop/orders/manage/find-by-filters',
    LATEST: '/api/v1/shop/orders/latest',
    MARK_AS_SHIPPED: (id: string) => `/api/v1/shop/orders/${id}/mark-as-shipped`,
    CANCEL: (id: string) => `/api/v1/shop/orders/${id}/cancel`,
    UPDATE_STATUS: (id: string) => `/api/v1/shop/orders/${id}/update-status`,
    GET_DETAILS: (orderId: string, orderItemId: string) => `/api/v1/shop/orders/${orderId}/${orderItemId}/admin/details`,
    GET_INVOICE: (orderId: string, orderItemId: string) => `/api/v1/shop/orders/${orderId}/${orderItemId}/admin/invoice`,
    CANCEL_ADMIN: (orderId: string, orderItemId: string) => `/api/v1/shop/orders/${orderId}/${orderItemId}/admin/cancel`,
    MARK_AS_READY_FOR_PICKUP: '/api/v1/shop/fulfillment/ready-for-pickup',
    MARK_AS_PICKED_UP: '/api/v1/shop/fulfillment/picked-up',
    RETURNS: '/api/v1/shop/returns/admin',
    GET_RETURN_DETAILS: (returnId: string) => `/api/v1/shop/returns/admin/${returnId}`,
    APPROVE_REJECT_RETURN: '/api/v1/shop/returns/admin/status',
    INITIATE_REFUND: (returnId: string) => `/api/v1/shop/returns/admin/${returnId}/refund`,
    APPROVE_REJECT_CANCELLATION: (orderId: string, orderItemId: string) => `/api/v1/shop/orders/${orderId}/${orderItemId}/admin/cancellation-decision`,
    INITIATE_CANCELLATION_REFUND: (orderId: string, orderItemId: string) => `/api/v1/shop/orders/${orderId}/${orderItemId}/admin/initiate-cancellation-refund`,
  },

  // ============================================
  // PROMOS (Future)
  // ============================================
  PROMOS: {
    LIST: '/api/v1/shop/promo',
    ADD: '/api/v1/shop/promo',
    UPDATE: (id: string) => `/api/v1/shop/promo/${id}`,
    GET_BY_ID: (id: string) => `/api/v1/shop/promo/${id}`,
    DELETE: (id: string) => `/api/v1/shop/promo/delete/${id}`,
    UPDATE_STATUS: (id: string) => `/api/v1/shop/promo/${id}`,
    APPLY: '/api/v1/shop/promo/apply',
  },

  // ============================================
  // ACADEMY (For Seller Locations)
  // ============================================
  ACADEMY: {
    LIST_WITH_CENTERS: '/api/v1/academy/list-with-centers',
  },
} as const;
